/* glowee-fixes.js — extracted from layout/theme.liquid inline <script> blocks. */
(function () {
  'use strict';

  /* Brand toast for user-visible errors (ATC fail, gift block, etc.) */
  function showGwToast(msg) {
    try {
      var existing = document.getElementById('gw-toast');
      if (existing) existing.remove();
      var t = document.createElement('div');
      t.id = 'gw-toast';
      t.setAttribute('role', 'status');
      t.setAttribute('aria-live', 'polite');
      t.textContent = msg;
      t.style.cssText = 'position:fixed;left:50%;bottom:24px;transform:translateX(-50%);background:#2C1B34;color:#FFFFFF;padding:12px 22px;border-radius:999px;font-family:Strawford,system-ui,sans-serif;font-size:14px;font-weight:500;box-shadow:0 12px 30px rgba(44,27,52,.30);z-index:99999;opacity:0;transition:opacity .25s ease;pointer-events:none;max-width:88vw;text-align:center;';
      document.body.appendChild(t);
      requestAnimationFrame(function () { t.style.opacity = '1'; });
      setTimeout(function () {
        t.style.opacity = '0';
        setTimeout(function () { t.remove(); }, 300);
      }, 3500);
    } catch (e) {}
  }
  window.showGwToast = showGwToast;

  /* === 0. Free-gift add-to-cart guard ===
     Block manual add-to-cart of the gift product. Programmatic adds with the
     `_free_gift: 'true'` property (issued by cart-gift-bar.liquid) pass through. */
  (function () {
    var giftCfg = window.GLOWEE_FREE_GIFT;
    if (!giftCfg || !Array.isArray(giftCfg.variantIds) || giftCfg.variantIds.length === 0) return;
    var giftIds = giftCfg.variantIds.map(function (id) { return String(id); });

    function isGiftId(id) {
      return id != null && giftIds.indexOf(String(id)) !== -1;
    }

    function payloadHasGiftProperty(props) {
      if (!props || typeof props !== 'object') return false;
      return props._free_gift === 'true' || props._free_gift === true;
    }

    function alertBlocked() {
      try {
        alert(giftCfg.currency === 'EUR'
          ? 'Tento produkt nie je možné kúpiť samostatne. Získate ho zadarmo pri prekročení nákupnej hranice v košíku.'
          : 'Tento produkt nelze koupit samostatně. Získáte ho zdarma při překročení nákupní hranice v košíku.');
      } catch (e) {}
    }

    function shouldBlock(items) {
      var arr = Array.isArray(items) ? items : [items];
      for (var i = 0; i < arr.length; i++) {
        var it = arr[i] || {};
        if (isGiftId(it.id) && !payloadHasGiftProperty(it.properties)) return true;
      }
      return false;
    }

    /* Normalize key/value add-to-cart bodies (FormData, URLSearchParams,
       form-urlencoded string) into the same shape as the JSON body so the gift
       check sees a nested `properties` object. Shopify sends gift metadata as
       `properties[_free_gift]=true` flat keys — rebuild those into properties.* */
    function reconstructPairs(each) {
      var obj = { properties: {} };
      var hasProps = false;
      each(function (k, v) {
        var m = /^properties\[(.+)\]$/.exec(k);
        if (m) { obj.properties[m[1]] = v; hasProps = true; }
        else { obj[k] = v; }
      });
      if (!hasProps) delete obj.properties;
      return obj;
    }

    function parseBody(body) {
      if (!body) return null;
      if (typeof body === 'string') {
        var s = body.replace(/^\s+/, '');
        if (s.charAt(0) === '{' || s.charAt(0) === '[') {
          try { return JSON.parse(body); } catch (e) { /* not JSON — try urlencoded */ }
        }
        try {
          var usp = new URLSearchParams(body);
          return reconstructPairs(function (cb) { usp.forEach(function (v, k) { cb(k, v); }); });
        } catch (e) { return null; }
      }
      if (typeof FormData !== 'undefined' && body instanceof FormData) {
        return reconstructPairs(function (cb) { body.forEach(function (v, k) { cb(k, v); }); });
      }
      if (typeof URLSearchParams !== 'undefined' && body instanceof URLSearchParams) {
        return reconstructPairs(function (cb) { body.forEach(function (v, k) { cb(k, v); }); });
      }
      /* Blob / ReadableStream / Request bodies can't be read synchronously — not
         inspectable here; the capture-phase click + submit guards backstop those. */
      return null;
    }

    function isCartAddUrl(url) {
      if (!url) return false;
      var u = String(url);
      return u.indexOf('/cart/add') !== -1;
    }

    /* Patch fetch */
    var origFetch = window.fetch;
    if (typeof origFetch === 'function') {
      window.fetch = function (input, init) {
        try {
          var url = typeof input === 'string' ? input : (input && input.url) || '';
          if (isCartAddUrl(url)) {
            var body = init && init.body;
            var parsed = parseBody(body);
            if (parsed) {
              var items = parsed.items || parsed;
              var idVal = parsed.id;
              var formItems = items;
              if (idVal != null && !Array.isArray(items)) {
                formItems = [{ id: idVal, properties: parsed.properties }];
              }
              if (shouldBlock(formItems)) {
                alertBlocked();
                return Promise.reject(new Error('Free-gift product blocked: manual add not allowed.'));
              }
            }
          }
        } catch (e) { /* fall through to original */ }
        return origFetch.apply(this, arguments);
      };
    }

    /* Patch XHR */
    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__glowee_url = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function (body) {
      try {
        if (isCartAddUrl(this.__glowee_url)) {
          var parsed = parseBody(body);
          if (parsed) {
            var items = parsed.items || parsed;
            var idVal = parsed.id;
            var formItems = items;
            if (idVal != null && !Array.isArray(items)) {
              formItems = [{ id: idVal, properties: parsed.properties }];
            }
            if (shouldBlock(formItems)) {
              alertBlocked();
              throw new Error('Free-gift product blocked: manual add not allowed.');
            }
          }
        }
      } catch (e) {
        if (e && e.message && e.message.indexOf('Free-gift') === 0) throw e;
      }
      return origSend.apply(this, arguments);
    };

    /* Block native form submit too (rare path: legacy non-AJAX add-to-cart forms) */
    document.addEventListener('submit', function (ev) {
      var form = ev.target;
      if (!form || form.tagName !== 'FORM') return;
      var action = form.getAttribute('action') || '';
      if (!isCartAddUrl(action)) return;
      var idInput = form.querySelector('input[name="id"], select[name="id"]');
      if (!idInput || !isGiftId(idInput.value)) return;
      var hasGiftProp = !!form.querySelector('input[name="properties[_free_gift]"][value="true"]');
      if (!hasGiftProp) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        alertBlocked();
      }
    }, true);

    /* Block the ATC button CLICK itself (capture phase) — stops the theme's own
       click→AJAX handler (which may use a fetch/XHR reference captured before our
       patches) from ever firing for the gift product. This is the robust catch-all. */
    document.addEventListener('click', function (ev) {
      var btn = ev.target.closest(
        'button[name="add"], [type="submit"], .product-form__submit, [data-add-to-cart], .hdt-pr_btn-atc, .add-to-cart, [data-pr-atc]'
      );
      if (!btn) return;
      var form = btn.closest('form[action*="/cart/add"], form[action*="/cart"]');
      var idVal = null;
      if (form) {
        var idInput = form.querySelector('input[name="id"], select[name="id"]');
        if (idInput) idVal = idInput.value;
      }
      if (idVal == null) idVal = btn.getAttribute('data-variant-id') || btn.getAttribute('data-id');
      if (!isGiftId(idVal)) return;
      var hasGiftProp = form && !!form.querySelector('input[name="properties[_free_gift]"][value="true"]');
      if (!hasGiftProp) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        alertBlocked();
      }
    }, true);
  })();

  /* === 0a2. Free-gift quantity clamp (max 1 ks / objednávku) ===
     The gift line's qty stepper is hidden in the cart UI, but a direct
     /cart/change.js (power user, or a leftover multi-qty line from before this
     fix) can still push the free gift above 1. Clamp any _free_gift line back to
     quantity 1 whenever the cart loads or mutates. */
  (function () {
    var clamping = false;
    function isGiftLine(it) {
      var p = it.properties || {};
      return p._free_gift === 'true' || p._free_gift === true;
    }
    function clampGift() {
      if (clamping) return;
      clamping = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var giftLines = (cart.items || []).filter(isGiftLine);
          // Desired state: exactly ONE gift line at quantity 1. Keep the first,
          // set it to 1 (if needed); remove any additional gift lines.
          var ops = [];
          giftLines.forEach(function (l, i) {
            if (i === 0) { if (l.quantity !== 1) ops.push({ id: l.key, quantity: 1 }); }
            else { ops.push({ id: l.key, quantity: 0 }); }
          });
          if (!ops.length) { clamping = false; return; }
          return ops.reduce(function (chain, op) {
            return chain.then(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(op)
              });
            });
          }, Promise.resolve()).then(function () {
            clamping = false;
            document.dispatchEvent(new CustomEvent('cart:reload'));
          });
        })
        .catch(function () { clamping = false; });
    }
    if (document.readyState !== 'loading') { clampGift(); }
    else { document.addEventListener('DOMContentLoaded', clampGift); }
    ['cart:reload', 'cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(clampGift, 300); });
    });
  })();

  /* === 0b. Free-gift checkout guard ===
     The <hdt-free-gift-bar> auto-add/remove is best-effort and can leave the gift
     in the cart when a customer drops below the threshold and goes straight to
     checkout (async remove unfinished / bar not re-rendered / processing lock).
     Here we intercept the checkout intent, revalidate against a FRESH /cart.js and
     remove the gift server-side BEFORE proceeding when the qualifying subtotal is
     below the threshold.
     NOT covered (theme cannot): discount codes entered on the Shopify checkout,
     and accelerated buttons (Shop Pay / PayPal). Only Shopify Functions or an
     automatic "free product" discount close those. */
  (function () {
    var cfg = window.GLOWEE_FREE_GIFT || {};
    var threshold = parseInt(cfg.threshold, 10);
    var giftEnabled = threshold > 0;

    var processing = false;
    var allowThrough = false;

    /* Set guard: „pastovy-set" je jednovariantní + příchutě = line-item properties.
       Karta-add cesty jsou opravené (needs_choice → odkaz na PDP), tohle je pojistka
       pro zbylé edge-case cesty (re-order, draft, appka, přímý /cart/add). */
    function setGuardHit(cart) {
      var sg = window.GLOWEE_SET_GUARD || {};
      var ids = (sg.variantIds || []).map(String);
      if (!ids.length) return false;
      var prefix = sg.propPrefix || 'Příchuť';
      var need = parseInt(sg.minProps, 10) || 1;
      var items = cart.items || [];
      for (var i = 0; i < items.length; i++) {
        var it = items[i];
        if (ids.indexOf(String(it.variant_id)) === -1 && ids.indexOf(String(it.id)) === -1) continue;
        var props = it.properties || {};
        var have = 0;
        Object.keys(props).forEach(function (k) {
          if (k.indexOf(prefix) === 0 && String(props[k]).trim() !== '') have++;
        });
        if (have < need) return true;
      }
      return false;
    }

    function isGiftLine(it) {
      var p = it.properties || {};
      return p._free_gift === 'true' || p._free_gift === true;
    }
    // Mirror cart-gift-bar.liquid: sum final_line_price of shippable, non-gift items.
    function qualifyingSubtotal(cart) {
      var sum = 0;
      (cart.items || []).forEach(function (it) {
        if (isGiftLine(it)) return;
        if (it.requires_shipping === false) return;
        sum += it.final_line_price;
      });
      return sum;
    }
    function giftKeys(cart) {
      return (cart.items || []).filter(isGiftLine).map(function (it) { return it.key; });
    }
    function removeKeys(keys) {
      return keys.reduce(function (chain, key) {
        return chain.then(function () {
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ id: key, quantity: 0 })
          });
        });
      }, Promise.resolve());
    }

    function proceedNative(el) {
      allowThrough = true;
      if (el && el.tagName === 'A' && el.href) { window.location.href = el.href; return; }
      var form = (el && (el.form || (el.closest && el.closest('form')))) || null;
      if (form && typeof form.requestSubmit === 'function') { form.requestSubmit(el || undefined); return; }
      if (form) { form.submit(); return; }
      if (el && el.click) { el.click(); return; }
      window.location.href = '/checkout';
    }

    function validateThenGo(el) {
      if (processing) return;
      processing = true;
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          // 1) Set bez příchutí → tvrdý blok, pošli na PDP setu vybrat příchutě.
          if (setGuardHit(cart)) {
            var sg = window.GLOWEE_SET_GUARD || {};
            if (window.showGwToast) {
              showGwToast(sg.currency === 'EUR'
                ? 'Pri výhodnom sete vyber najprv 4 príchute.'
                : 'U výhodného setu nejdřív vyber 4 příchutě.');
            }
            processing = false;
            window.location.href = (sg.url || '/products/pastovy-set');
            return;
          }
          // 2) Free-gift práh (jen když je gift nakonfigurovaný).
          if (giftEnabled) {
            var keys = giftKeys(cart);
            if (keys.length && qualifyingSubtotal(cart) < threshold) {
              if (window.showGwToast) {
                var _amt = Math.round(threshold / 100);
                showGwToast(cfg.currency === 'EUR'
                  ? ('Darček platí od ' + _amt + ' € — z košíka bol odobraný.')
                  : ('Dárek platí od ' + _amt + ' Kč — z košíku byl odebrán.'));
              }
              return removeKeys(keys).then(function () {
                window.location.href = '/checkout';
              });
            }
          }
          // qualifies (or nothing to fix) → let the native checkout flow run
          proceedNative(el);
        })
        .catch(function () {
          // fail OPEN — never block a legitimate purchase on a network hiccup
          proceedNative(el);
        });
    }

    document.addEventListener('click', function (e) {
      if (allowThrough) return;
      var el = e.target && e.target.closest
        ? e.target.closest('button[name="checkout"], a[href*="/checkout"]')
        : null;
      if (!el) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      validateThenGo(el);
    }, true);

    document.addEventListener('submit', function (e) {
      if (allowThrough) return;
      var form = e.target;
      if (!form || !form.querySelector) return;
      var btn = form.querySelector('button[name="checkout"], [name="checkout"]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      validateThenGo(btn);
    }, true);
  })();

  /* === 1. Breadcrumb relocation (collection page with main-heading section) ===
     Original: hardcoded #shopify-section-template--<themeId>__main_heading_PHNGje
     Replacement: scope by body class set from {{ template.suffix }} so theme republish
     does not break it. Behavior preserved 1:1 for the belici-produkty collection. */
  function relocateBreadcrumb() {
    if (!document.body.classList.contains('template-suffix-belici-produkty')) return;

    var headingSection = document.querySelector(
      '.shopify-section [class*="hdt-heading-section"], .shopify-section .hdt-heading-image'
    );
    var sectionEl = headingSection ? headingSection.closest('.shopify-section') : null;
    var breadcrumbInBanner = sectionEl ? sectionEl.querySelector('.hdt-breadcrumb') : null;
    if (breadcrumbInBanner) {
      breadcrumbInBanner.style.display = 'none';
    }

    setTimeout(function () {
      var bannerSection = document.querySelector('.shopify-section .hdt-heading-image');
      var sectionParent = bannerSection ? bannerSection.closest('.shopify-section') : null;
      var breadcrumb = sectionParent ? sectionParent.querySelector('.hdt-breadcrumb') : null;
      var controlRow = document.querySelector('.hdt-row-flex.hdt-flex-cols-3');

      if (breadcrumb && controlRow) {
        controlRow.style.cssText = 'display: flex !important; align-items: center !important; justify-content: space-between !important; flex-wrap: nowrap !important; column-gap: 0 !important;';

        var breadcrumbCol = document.createElement('div');
        breadcrumbCol.className = 'hdt-flex-cols-1 hdt-col breadcrumb-middle-col';
        breadcrumbCol.style.cssText = 'position: absolute !important; left: 50% !important; transform: translateX(-50%) !important; white-space: nowrap !important;';

        breadcrumbCol.appendChild(breadcrumb);
        breadcrumb.style.cssText = 'display: inline-flex !important; margin: 0 !important; white-space: nowrap !important;';

        var breadcrumbList = breadcrumb.querySelector('.hdt-breadcrumb-list');
        if (breadcrumbList) {
          breadcrumbList.style.cssText = 'display: inline-flex !important; white-space: nowrap !important;';
        }

        var filterCol = controlRow.querySelector('.hdt-control-filter');
        var sortingCol = controlRow.querySelector('.hdt-control-sorting');

        if (filterCol) filterCol.style.cssText = 'flex: 0 0 auto !important; position: relative !important; z-index: 1 !important;';
        if (sortingCol) sortingCol.style.cssText = 'flex: 0 0 auto !important; position: relative !important; z-index: 1 !important;';

        controlRow.style.position = 'relative';

        if (sortingCol) {
          controlRow.insertBefore(breadcrumbCol, sortingCol);
        }
      }
    }, 200);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', relocateBreadcrumb);
  } else {
    relocateBreadcrumb();
  }

  /* === 2. Custom reviews badge on mobile (Judge.me replacement) === */
  if (window.innerWidth <= 768) {
    setTimeout(function () {
      var judgeWidget = document.querySelector('.jdgm-widget.jdgm-all-reviews-text');
      if (!judgeWidget || document.querySelector('.custom-reviews-badge')) return;

      var customBadge = document.createElement('div');
      customBadge.className = 'custom-reviews-badge';
      customBadge.style.cssText = 'padding: 0; margin: -40px 0 12px; width: 100%; display: block; text-align: center; position: relative; z-index: 10;';
      customBadge.innerHTML =
        '<div style="display: inline-flex; flex-direction: column; align-items: center; gap: 3px; padding: 10px 24px; background: #fff; border-radius: 999px; box-shadow: 0 4px 14px rgba(0,0,0,0.08); margin: 0 auto;">' +
          '<div style="display: flex; align-items: center; gap: 7px; line-height: 1; white-space: nowrap;">' +
            '<span style="font-size: 26px; font-weight: 700; color: #000; line-height: 1;">4.6</span>' +
            '<span style="display: inline-flex; gap: 3px;">' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="#FFB400" style="filter: drop-shadow(0 0 0.5px rgba(0,0,0,0.2));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="#FFB400" style="filter: drop-shadow(0 0 0.5px rgba(0,0,0,0.2));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="#FFB400" style="filter: drop-shadow(0 0 0.5px rgba(0,0,0,0.2));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="#FFB400" style="filter: drop-shadow(0 0 0.5px rgba(0,0,0,0.2));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
              '<svg width="22" height="22" viewBox="0 0 24 24" fill="#FFB400" style="filter: drop-shadow(0 0 0.5px rgba(0,0,0,0.2));"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/></svg>' +
            '</span>' +
          '</div>' +
          '<div style="font-size: 11px; color: #000; line-height: 1.1; font-weight: 500; text-align: center;">' +
            '4.6 z 5 hvězdiček z <strong style="color: #000;">809 ověřených recenzí</strong>' +
          '</div>' +
        '</div>';

      judgeWidget.parentNode.insertBefore(customBadge, judgeWidget);
    }, 100);
  }

  /* === 3. Delivery date estimator === */
  function updateDeliveryDate() {
    var now = new Date();
    var currentHour = now.getHours();

    var daysToAdd = 2;
    if (currentHour >= 12) {
      daysToAdd = 3;
    }

    var deliveryDate = new Date(now);
    var addedDays = 0;

    while (addedDays < daysToAdd) {
      deliveryDate.setDate(deliveryDate.getDate() + 1);
      var dayOfWeek = deliveryDate.getDay();
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        addedDays++;
      }
    }

    var day = String(deliveryDate.getDate()).padStart(2, '0');
    var month = String(deliveryDate.getMonth() + 1).padStart(2, '0');
    var year = deliveryDate.getFullYear();
    var dateStr = day + '.' + month + '.' + year;

    if (document.querySelector('.delivery-estimate-box')) {
      var existingBox = document.querySelector('.delivery-estimate-box .delivery-date-text');
      if (existingBox) {
        existingBox.textContent = dateStr;
      }
      return;
    }

    var mainBtn = document.querySelector('.hdt-product-form__submit:not([class*="sticky"])');

    if (mainBtn) {
      var deliveryBox = document.createElement('div');
      deliveryBox.className = 'delivery-estimate-box';
      deliveryBox.style.cssText = 'text-align: center; margin-top: 12px; font-size: 16px; color: #666;';
      deliveryBox.innerHTML = '📦 Doručení: <strong class="delivery-date-text">' + dateStr + '</strong>';

      var formButtons = mainBtn.closest('.hdt-product-form__buttons') || mainBtn.closest('hdt-buy-buttons');
      if (formButtons && formButtons.parentElement) {
        formButtons.parentElement.insertBefore(deliveryBox, formButtons.nextSibling);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateDeliveryDate);
  } else {
    updateDeliveryDate();
  }
  setTimeout(updateDeliveryDate, 500);

  /* === 4. Scroll gradient animation (homepage + collections) — DISABLED === */
  (function () {
    return; // background switched to plain white; gradient disabled
    var isHomepage = document.body.classList.contains('hdt-page-type-index');
    var isCollection = document.body.classList.contains('hdt-page-type-collection');
    if (!isHomepage && !isCollection) return;

    var colors = {
      topStart: { r: 255, g: 71, b: 204, a: 0.06 },
      midStart: { r: 255, g: 255, b: 255, a: 1 },
      bottomStart: { r: 147, g: 112, b: 219, a: 0.08 },
      topEnd: { r: 255, g: 255, b: 255, a: 1 },
      midEnd: { r: 147, g: 112, b: 219, a: 0.06 },
      bottomEnd: { r: 75, g: 0, b: 130, a: 0.1 }
    };

    function lerp(start, end, progress) {
      return start + (end - start) * progress;
    }

    function interpolateColor(startColor, endColor, progress) {
      return {
        r: Math.round(lerp(startColor.r, endColor.r, progress)),
        g: Math.round(lerp(startColor.g, endColor.g, progress)),
        b: Math.round(lerp(startColor.b, endColor.b, progress)),
        a: lerp(startColor.a, endColor.a, progress).toFixed(3)
      };
    }

    function colorToRgba(color) {
      return 'rgba(' + color.r + ', ' + color.g + ', ' + color.b + ', ' + color.a + ')';
    }

    function throttle(func, limit) {
      var inThrottle;
      return function () {
        var args = arguments;
        var context = this;
        if (!inThrottle) {
          func.apply(context, args);
          inThrottle = true;
          setTimeout(function () { inThrottle = false; }, limit);
        }
      };
    }

    function updateGradient() {
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      var docHeight = document.documentElement.scrollHeight - window.innerHeight;
      var scrollProgress = Math.min(scrollTop / docHeight, 1);

      var topColor = interpolateColor(colors.topStart, colors.topEnd, scrollProgress);
      var midColor = interpolateColor(colors.midStart, colors.midEnd, scrollProgress);
      var bottomColor = interpolateColor(colors.bottomStart, colors.bottomEnd, scrollProgress);

      document.body.style.setProperty('--scroll-gradient-top', colorToRgba(topColor));
      document.body.style.setProperty('--scroll-gradient-mid', colorToRgba(midColor));
      document.body.style.setProperty('--scroll-gradient-bottom', colorToRgba(bottomColor));
    }

    updateGradient();
    window.addEventListener('scroll', throttle(updateGradient, 16), { passive: true });
    window.addEventListener('resize', throttle(updateGradient, 100), { passive: true });
  })();
})();


/* ============================================================
   Glowee — AJAX cart hijack + open drawer
   Skips forms inside <hdt-buy-buttons> / <hdt-sticky-btn-atc>
   (theme already AJAX-handles those).
   ============================================================ */
(function () {
  function openCartDrawer() {
    var trigger = document.querySelector('[aria-controls="CartDrawer"]');
    if (trigger) { trigger.click(); return; }
    var dlg = document.querySelector('#CartDrawer');
    if (dlg && !dlg.open && typeof dlg.showModal === 'function') {
      try { dlg.showModal(); } catch (e) {}
    }
  }

  function refreshDrawer() {
    return fetch('/?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (json) {
        var html = json && json['cart-drawer'];
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html.trim();
        // Surgically replace only the inner pieces inside #CartDrawer (preserve dialog + scroll position)
        var selectors = [
          'cart-items-component',
          '.hdt-mini-cart__threshold[ref="shipping-bar"]',
          '.hdt-mini-cart__threshold[ref="gift-bar"]',
          '.hdt-mini-cart__bottom'
        ];
        selectors.forEach(function (sel) {
          var newEl = tmp.querySelector(sel);
          var oldEl = document.querySelector('#CartDrawer ' + sel);
          if (newEl && oldEl) {
            oldEl.replaceWith(newEl);
          }
        });
      })
      .catch(function () {});
  }

  function updateCartCount() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var count = cart.item_count;
        document.querySelectorAll('[data-cart-count], .hdt-count-box, .cart-count').forEach(function (el) {
          el.textContent = count;
        });
      })
      .catch(function () {});
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var action = (form.getAttribute('action') || '').toLowerCase();
    if (action.indexOf('/cart/add') === -1) return;
    // theme custom elements already AJAX add → skip
    if (form.closest('hdt-buy-buttons')) return;
    if (form.closest('hdt-sticky-btn-atc')) return;
    if (form.hasAttribute('data-no-ajax-cart')) return;
    if (form._gwSubmitting) { e.preventDefault(); return; }

    e.preventDefault();
    e.stopPropagation();
    form._gwSubmitting = true;

    var submitBtn = form.querySelector('button[type="submit"], button[name="add"]');
    if (submitBtn) submitBtn.setAttribute('disabled', 'true');

    var data = new FormData(form);
    fetch('/cart/add.js', {
      method: 'POST',
      body: data,
      headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        // If on cart page, reload to reflect new item — otherwise refresh drawer + open
        if (document.body.classList.contains('hdt-page-type-cart')) {
          window.location.reload();
          return;
        }
        return Promise.all([refreshDrawer(), updateCartCount()]);
      })
      .then(function () {
        if (!document.body.classList.contains('hdt-page-type-cart')) openCartDrawer();
      })
      .catch(function () {
        showGwToast('Něco se pokazilo. Zkus to prosím znovu.');
        // fallback to native submit
        form.setAttribute("data-no-ajax-cart", "true");
        form.submit();
      })
      .finally(function () {
        form._gwSubmitting = false;
        if (submitBtn) submitBtn.removeAttribute('disabled');
      });
  }, false);

  // Listen to native cart added events from theme's own AJAX (hdt-buy-buttons) → ensure drawer opens
  document.addEventListener('cart:item-added', openCartDrawer);
  document.addEventListener('product:added-to-cart', openCartDrawer);

  // Delegated handler for cart remove / quantity links inside drawer (safety net if theme handlers detach)
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest && e.target.closest('a[href*="/cart/change"]');
    if (!a) return;
    if (!a.closest('#CartDrawer')) return;
    e.preventDefault();
    e.stopPropagation();
    var url = new URL(a.getAttribute('href'), window.location.origin);
    var line = url.searchParams.get('line');
    var qty = url.searchParams.get('quantity');
    if (!line) return;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(qty || '0', 10) })
    })
      .then(function () { return Promise.all([refreshDrawer(), updateCartCount()]); })
      .catch(function () {});
  }, true);

  /* Donation checkbox „Přidej pastu dětem" — přidá/odebere DAR-DD a obnoví košík.
     Delegováno na document → přežije re-render draweru. */
  document.addEventListener('change', function (e) {
    var cb = e.target;
    if (!cb || !cb.matches || !cb.matches('[data-gw-donation]')) return;
    var vid = cb.getAttribute('data-variant-id');
    if (!vid) return;
    cb.disabled = true;
    var onCartPage = document.body.classList.contains('hdt-page-type-cart');
    var wantAdd = cb.checked;
    var req = wantAdd
      ? fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: vid, quantity: 1 })
        })
      : fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: vid, quantity: 0 })
        });
    req
      .then(function (r) { if (!r.ok) throw new Error('donation_fail'); return r.json(); })
      .then(function () {
        if (onCartPage) { window.location.reload(); return; }
        return Promise.all([refreshDrawer(), updateCartCount()]);
      })
      .catch(function () {
        if (typeof showGwToast === 'function') showGwToast('Něco se pokazilo. Zkus to prosím znovu.');
        cb.checked = !wantAdd;
      })
      .finally(function () { cb.disabled = false; });
  }, false);

  /* ---- Copy-to-clipboard slevových kódů (announcement bar + PDP box) ----
     Delegováno na document → funguje i pro pozdě vložené prvky. Prvek s
     [data-gw-copy] a atributem data-code; po zkopírování třída .is-copied
     (přepne ikonu na fajfku) + brand toast. */
  document.addEventListener('click', function (e) {
    var el = e.target && e.target.closest ? e.target.closest('[data-gw-copy]') : null;
    if (!el) return;
    e.preventDefault();
    var code = el.getAttribute('data-code') || (el.textContent || '').trim();
    if (!code) return;

    function done() {
      el.classList.add('is-copied');
      if (typeof showGwToast === 'function') showGwToast('Kód zkopírován ✓');
      setTimeout(function () { el.classList.remove('is-copied'); }, 1800);
    }
    function fallback() {
      try {
        var ta = document.createElement('textarea');
        ta.value = code;
        ta.setAttribute('readonly', '');
        ta.style.cssText = 'position:absolute;left:-9999px;top:0;';
        document.body.appendChild(ta);
        ta.select();
        document.execCommand('copy');
        document.body.removeChild(ta);
        done();
      } catch (err) {
        if (typeof showGwToast === 'function') showGwToast('Zkopíruj kód ručně: ' + code);
      }
    }

    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(fallback);
    } else {
      fallback();
    }
  }, false);
})();

/* === Cart drawer: pin the bottom bar (CTA always visible), single scroll area ===
   The vendor cart drawer re-renders on every cart change (wiping layout styles) and lets the bottom
   (subtotal + delivery + "Zobrazit košík") fall below the fold on taller carts. CSS overrides don't
   stick reliably, so force the flex layout via inline !important: only the item list scrolls, the
   bottom stays pinned. Re-applied after every re-render. */
(function () {
  'use strict';
  function pin() {
    var d = document.getElementById('CartDrawer');
    if (!d) return;
    function set(sel, props) {
      var el = d.querySelector(sel);
      if (!el) return;
      for (var k in props) { el.style.setProperty(k, props[k], 'important'); }
    }
    set('.hdt-dialog-drawer__inner', { display: 'flex', 'flex-direction': 'column', 'min-height': '0' });
    set('cart-items-component', { display: 'flex', 'flex-direction': 'column', flex: '1 1 auto', 'min-height': '0', overflow: 'hidden' });
    set('.hdt-mini-cart__main', { display: 'flex', 'flex-direction': 'column', flex: '1 1 auto', 'min-height': '0', overflow: 'hidden' });
    set('.hdt-mini-cart__sroll', { flex: '1 1 auto', 'min-height': '0', 'overflow-y': 'auto', 'overflow-x': 'hidden' });
    set('.hdt-mini-cart__bottom', { flex: '0 0 auto' });
    set('.hdt-mini-cart__bottom-wrap', { overflow: 'visible', 'max-height': 'none', 'padding-top': '14px', 'padding-bottom': '14px' });
    /* compact spacing (vendor classes need inline to stick) */
    set('.hdt-totals', { 'margin-bottom': '2px' });
    set('.hdt-mini-cart__btn-viewcart', { 'margin-top': '6px', 'padding-top': '11px', 'padding-bottom': '11px', 'min-height': '0', 'max-height': 'none' });
    set('.hdt-mini-cart__imgtrust', { 'margin-top': '10px' });
    /* Hide the native btn_checkout — it duplicates our guarded pink "K pokladně" (.gw-drawer-checkout). */
    set('.hdt-mini-cart__btn-checkout', { display: 'none' });
  }
  var queued = false;
  function pinThrottled() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; pin(); });
  }
  function schedule() { pin(); setTimeout(pin, 60); setTimeout(pin, 300); setTimeout(pin, 800); }
  if (document.readyState !== 'loading') schedule(); else document.addEventListener('DOMContentLoaded', schedule);
  ['cart:reload', 'cart:refresh', 'cart:change', 'cart:update'].forEach(function (ev) {
    document.addEventListener(ev, schedule);
  });
  try {
    var obs = new MutationObserver(pinThrottled);
    obs.observe(document.documentElement, { subtree: true, childList: true });
  } catch (e) {}
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[aria-controls="CartDrawer"]')) schedule();
  }, true);
})();

/* === Cart drawer: "K pokladně" guard — NEVER checkout with pickup method but no point selected ===
   Globe can't enforce inside Shopify checkout on non-Plus, so we gate the drawer checkout here.
   Signals (cart attributes): globe_DeliveryMethod = 'home' | 'pickup'; globe_PickupPointId set when a point is chosen. */
(function () {
  'use strict';
  function scrollToPickup() {
    var p = document.querySelector('#CartDrawer .gw-pickup-point');
    if (!p) return;
    try { p.scrollIntoView({ behavior: 'smooth', block: 'center' }); } catch (e) {}
    p.style.transition = 'box-shadow .25s ease';
    p.style.borderRadius = '14px';
    p.style.boxShadow = '0 0 0 3px rgba(237,63,138,.55)';
    setTimeout(function () { p.style.boxShadow = ''; }, 1600);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('.gw-drawer-checkout, #CartDrawer button[name="checkout"], #CartDrawer .hdt-mini-cart__btn-checkout');
    if (!btn) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var a = (cart && cart.attributes) || {};
        var method = a.globe_DeliveryMethod;
        if (!method) {
          if (typeof showGwToast === 'function') showGwToast('Vyber prosím způsob doručení — domů nebo výdejní místo.');
          scrollToPickup();
          return;
        }
        if (method === 'pickup' && !a.globe_PickupPointId) {
          if (typeof showGwToast === 'function') showGwToast('Nejdřív vyber konkrétní výdejní místo.');
          scrollToPickup();
          return;
        }
        window.location.href = '/checkout';
      })
      .catch(function () {
        /* can't verify → go to the cart page (Globe enforces there), never straight to checkout */
        window.location.href = '/cart';
      });
  }, true);
})();
